export default {
    //쿠키 설정 name: 쿠키이름, value: 쿠키값, exp: 만료시
    setCookie: function(name, value) {
        var date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    },

    // 1분 
    setCookieTest: function(name, value) {
        var date = new Date();
        date.setTime(date.getTime() + 60 * 1000);
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    },

    //쿠키 얻기 name: 쿠키이름
    getCookie: function(name) {
        var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value ? value[2] : null;
    },

    //쿠키 삭제 name: 쿠키이름
    deleteCookie: function(name) {
        // alert("delete: " + name)
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}


// WEBPACK FOOTER //
// ./src/utilities/cookie.js